import { withInstall } from '@hd-front-end/utils'
import Tag from './src/tag.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElTag: SFCWithInstall<typeof Tag> = withInstall(Tag)
export default ElTag

export * from './src/tag'
